import axiosInstance from "./axiosInstance";

const receivableService = {
    create: async (payload) => {
        try {
            const response = await axiosInstance.post('/receivables/create', payload)
            return response.data
        } catch (error) {
            console.log(error.response.data)
        }
    },
    fetchByCustomer: async (id) => {
      try {
          const response = await axiosInstance.get('/receivables/customer/' + id)
          return response.data
      } catch (error) {
          console.log(error)
      }
    },
    fetchAll: async () => {
        try {
            const response = await axiosInstance.get('/receivables/all')
            return response.data
        } catch (error) {
            console.log(error.response.data)
        }
    },
    fetch: async (id) => {
        try {
            const response = await axiosInstance.get('/receivables/single/' + id)
            return response.data
        } catch (error) {
            console.log(error.response.data)
        }
    },
    update: async (id, payload) => {
        try {
            const response = await axiosInstance.put('/receivables/update/' + id, payload)
            return response.data
        } catch (error) {
            console.log(error.response.data)
        }
    },
    clear: async (chequeNumber) => {
        try {
            const response = await axiosInstance.put('/receivables/clear/' + chequeNumber)
            return response.data
        } catch (error) {
            console.log(error.response.data)
        }
    },

    
    delete: async (id) => {
        try {
            const response = await axiosInstance.delete('/receivables/delete/' + id)
            return response.data
        } catch (error) {
            console.log(error.response.data)
        }
    }
}

export default receivableService
